module.exports = __webpack_public_path__ + "img/grocery.7cf1bfc8.png";